import {Component, OnInit} from '@angular/core';
import * as $ from 'jquery';
import {Router, ActivatedRoute, Event, NavigationEnd} from '@angular/router';
import {filter} from 'rxjs/operators';
import {TranslateServiceService} from '../translate-service.service';
import {Subscription} from 'rxjs';
import {HttpParams, HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Component({
  selector: 'app-routing-component',
  templateUrl: './routing-component.component.html',
  styleUrls: ['./routing-component.component.scss']
})
export class RoutingComponentComponent implements OnInit {

  private lang: string;
  private sub: Subscription;

  constructor(private translateService: TranslateServiceService, private route: Router, private http: HttpClient) {
    this.translateService.lang.subscribe(lang => {
      this.lang = lang;
      let urlArr = this.route.url.split('/').slice(1);
      urlArr[0] = this.lang;
      console.log(urlArr);
      this.route.navigate(urlArr);
      // location.reload()
    });

  }

  ngOnInit() {

  }
}
